// //þessi útgáfa sækir úr json
// // frontend/src/pages/DoctorChangeDetailPage.tsx
// import React, { useEffect, useMemo, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import Header from '../components/Header/Header';
// import SearchBar, { SearchBarProps } from '../components/SearchBar/SearchBar';
// import Background from '../components/Background/Background';
// import '../styles/DoctorChangeDetailPage.css';
// import { useAuth0 } from '@auth0/auth0-react';
// import { fetchWithAuth } from '../api/fetchWithAuth';

// type EffectiveKind = 'immediate' | 'next_cycle';

// type ActionItem = {
//   name: string;
//   instruction?: string;
//   effective?: EffectiveKind;
// };

// type PharmacistDecision = {
//   medicationName: string;
//   kind: 'add' | 'edit' | 'remove';
//   decision: 'approved' | 'rejected';
//   effective: EffectiveKind | null;
//   reason: string | null;
//   decidedAt: string;
// };

// type ChangeEntry = {
//   name: string;
//   ssn: string;
//   date: string;
//   time: string;
//   sender: string;
//   phone: string;
//   actions?: {
//     add?: ActionItem[];
//     edit?: ActionItem[];
//     remove?: ActionItem[];
//     pharmacist?: PharmacistDecision[];
//   };
// };

// type Row = {
//   kind: 'add' | 'edit' | 'remove';
//   name: string;
//   instruction?: string;
//   effective?: EffectiveKind;
//   pharmacistDecision?: 'approved' | 'rejected';
//   rejectReason?: string | null;
// };

// const kindLabel: Record<Row['kind'], string> = {
//   add: 'Nýtt lyf',
//   edit: 'Breyting',
//   remove: 'Lyf tekið úr skömmtun',
// };

// export default function DoctorChangeDetailPage() {
//   const { ssn = '' } = useParams();
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState<'medications' | 'history'>('history');
//   const [searchSsn, setSearchSsn] = useState('');

//   const [loading, setLoading] = useState(true);
//   const [entry, setEntry] = useState<ChangeEntry | null>(null);
//   const [err, setErr] = useState('');

//   const API_BASE = 'http://localhost:4000';
//   const { getAccessTokenSilently } = useAuth0();

//   const handleSearch = async () => {
//     const ssnTrimmed = searchSsn.trim();
//     if (!ssnTrimmed) return;

//     try {
//       const res = await fetchWithAuth(getAccessTokenSilently, `${API_BASE}/api/patients/search`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ ssn: ssnTrimmed }),
//       });

//       if (res.status === 404) {
//         navigate('/notfound');
//         return;
//       }

//       if (!res.ok) {
//         const text = await res.text();
//         throw new Error(`API ${res.status}: ${text}`);
//       }

//       const data = await res.json();
//       console.log('PATIENT FROM API:', data);
//       console.log(
//         'MED IDS:',
//         data.medications?.map((m: any) => m.id)
//       );
//       const newPatientId = data.patientId as string | undefined;
//       if (!newPatientId) throw new Error('Missing patientId in search response');

//       navigate(`/doctor/patient/${encodeURIComponent(newPatientId)}`, {
//         state: { name: data.name, pharmacy: data.pharmacy },
//       });
//     } catch (e) {
//       console.error(e);
//       navigate('/notfound');
//     }
//   };

//   const searchProps: SearchBarProps = {
//     value: searchSsn,
//     onChange: setSearchSsn,
//     onSearch: handleSearch,
//     onMenuClick: () => console.log('menu'),
//   };

//   useEffect(() => {
//     (async () => {
//       try {
//         setLoading(true);
//         setErr('');
//         const res = await fetchWithAuth(
//           getAccessTokenSilently,
//           `${API_BASE}/api/changes/${encodeURIComponent(ssn.trim())}`
//         );
//         if (!res.ok) {
//           const text = await res.text();
//           throw new Error(`API ${res.status}: ${text}`);
//         }
//         const data = (await res.json()) as ChangeEntry;
//         setEntry(data);
//       } catch (e: any) {
//         console.error(e);
//         setErr(e?.message || 'Villa kom upp');
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, [ssn, getAccessTokenSilently]);

//   const rows = useMemo<Row[]>(() => {
//     if (!entry) return [];
//     const acts = entry.actions ?? {};
//     const pharmacist = acts.pharmacist ?? [];

//     const decisionMap = new Map<string, PharmacistDecision>();
//     pharmacist.forEach((p) => decisionMap.set(`${p.kind}::${p.medicationName}`, p));

//     const push = (kind: Row['kind'], a: ActionItem) => {
//       const d = decisionMap.get(`${kind}::${a.name}`);
//       return {
//         kind,
//         name: a.name,
//         instruction: a.instruction,
//         effective: a.effective,
//         pharmacistDecision: d?.decision,
//         rejectReason: d?.reason ?? null,
//       } as Row;
//     };

//     const out: Row[] = [];
//     (acts.add ?? []).forEach((a) => out.push(push('add', a)));
//     (acts.edit ?? []).forEach((a) => out.push(push('edit', a)));
//     (acts.remove ?? []).forEach((a) => out.push(push('remove', a)));

//     return out;
//   }, [entry, getAccessTokenSilently]);

//   return (
//     <>
//       <Header
//         title="Rx"
//         userName="Jón Jónsson"
//         center={<SearchBar {...searchProps} />}
//       />
//       <div className="tabs">
//         <button
//           className={`tab ${activeTab === 'medications' ? 'active' : ''}`}
//           onClick={() => {
//             setActiveTab('medications');
//             navigate('/doctor');
//           }}
//         >
//           Lyfjaskammtanir
//         </button>
//         <button
//           className={`tab ${activeTab === 'history' ? 'active' : ''}`}
//           onClick={() => {
//             setActiveTab('history');
//             navigate('/doctor/changes');
//           }}
//         >
//           Þínar fyrri breytingar
//         </button>
//       </div>
//       <Background>
//         <div className="doc-detail">
//           <button className="doc-back" onClick={() => navigate('/doctor/changes')}>
//             ← Til baka
//           </button>

//           {loading && <div style={{ color: '#fff' }}>Hleð…</div>}
//           {err && <div style={{ color: '#fff' }}>{err}</div>}

//           {!loading && entry && (
//             <>
//               <div className="doc-detail-head">
//                 <div className="doc-name">{entry.name}</div>
//                 <div className="doc-sub">
//                   {entry.ssn} • {entry.date} | {entry.time}
//                 </div>
//               </div>

//               <div className="doc-rows">
//                 {rows.map((r) => (
//                   <div
//                     key={`${r.kind}-${r.name}`}
//                     className={
//                       'doc-row ' +
//                       (r.pharmacistDecision === 'approved'
//                         ? 'ok'
//                         : r.pharmacistDecision === 'rejected'
//                           ? 'bad'
//                           : 'pending')
//                     }
//                   >
//                     <div className="doc-row-left">
//                       <div className="doc-row-name">{r.name}</div>
//                       <div className="doc-row-meta">{kindLabel[r.kind]}</div>
//                     </div>

//                     <div className="doc-row-mid">
//                       {r.instruction ? (
//                         <span className="doc-pill">{r.instruction}</span>
//                       ) : (
//                         <span>—</span>
//                       )}
//                     </div>

//                     <div className="doc-row-right">
//                       {r.pharmacistDecision === 'approved' && (
//                         <span className="doc-chip ok">✓ Samþykkt</span>
//                       )}
//                       {r.pharmacistDecision === 'rejected' && (
//                         <span className="doc-chip bad" title={r.rejectReason || ''}>
//                           ✕ Hafnað
//                         </span>
//                       )}
//                       {!r.pharmacistDecision && <span className="doc-chip pending">Í vinnslu</span>}
//                     </div>

//                     {r.pharmacistDecision === 'rejected' && r.rejectReason && (
//                       <div className="doc-reason">Ástæða: {r.rejectReason}</div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </>
//           )}
//         </div>
//       </Background>
//     </>
//   );
// }

//þessi útgáfa sækir úr db
// frontend/src/pages/DoctorChangeDetailPage.tsx
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header/Header';
import SearchBar, { SearchBarProps } from '../components/SearchBar/SearchBar';
import Background from '../components/Background/Background';
import '../styles/DoctorChangeDetailPage.css';
import { useAuth0 } from '@auth0/auth0-react';
import { fetchWithAuth } from '../api/fetchWithAuth';

type WorkOrderStatus =
  | 'PENDING'
  | 'PARTIALLY_APPROVED'
  | 'APPROVED'
  | 'REJECTED'
  | 'CANCELLED'
  | 'COMPLETED_EXTERNALLY';

type WorkOrderType = 'CHANGE' | 'REGISTRATION' | 'DISPENSING_STATUS';
type ItemAction = 'ADD' | 'EDIT' | 'REMOVE' | 'PAUSE' | 'RESUME';

type WorkOrder = {
  work_order_id: string;
  order_type: WorkOrderType;
  patient_id: string;
  pharmacy_id: string;
  status: WorkOrderStatus;
  created_at: string;
};

type WorkOrderItem = {
  item_id: string;
  action: ItemAction;
  medication_identifier: string;
  proposed_payload: any;
  reviewed_at: string | null;
  decision: 'APPROVE' | 'DENY' | null;
  reason_code: string | null;
  notesPlaintext?: string | null;
};

type WorkOrderResponse = {
  workOrder: WorkOrder;
  items: WorkOrderItem[];
};

function kindLabel(a: ItemAction) {
  if (a === 'ADD') return 'Nýtt lyf';
  if (a === 'EDIT') return 'Breyting á lyfi';
  if (a === 'REMOVE') return 'Lyf tekið úr skömmtun';
  if (a === 'PAUSE') return 'Stöðva skömmtun';
  if (a === 'RESUME') return 'Endurvekja skömmtun';
  return a;
}

// If you don’t yet have a “catalog endpoint” for labels,
// this keeps the UI readable immediately.
const REASON_LABELS: Record<string, string> = {
  PRESCRIPTION_MISSING: 'Vantar lyfseðil',
  DOSE_WORRY: 'Áhyggjur af því að vitlaus skammtur hafi verið valinn',
  MEDICATION_WORRY: 'Áhyggjur af því að vitlaust lyf hafi verið valið',
  INTERACTION_RISK: 'Óæskilegar milliverkanir',
  NOT_ELIGIBLE: 'Lyf hentar ekki lyfjaskömmtun',
  MISMATCH: 'Ordination í kerfi passar ekki við lyfseðil sem var sendur',
  OTHER: 'Annað',
};

const statusLabel: Record<string, string> = {
  APPROVED: 'SAMÞYKKT',
  REJECTED: 'HAFNAÐ',
  PARTIALLY_APPROVED: 'SAMÞYKKT AÐ HLUTA',
  PENDING: 'Í VINNSLU',
  CANCELLED: 'AFTURKALLAÐ',
  COMPLETED_EXTERNALLY: 'LOKIÐ',
};

export default function DoctorChangeDetailPage() {
  const { workOrderId = '' } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'medications' | 'history'>('history');

  const [searchSsn, setSearchSsn] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const [wo, setWo] = useState<WorkOrder | null>(null);
  const [items, setItems] = useState<WorkOrderItem[]>([]);

  // Resubmit UI
  const [prescriptionsSent, setPrescriptionsSent] = useState(false);
  const [resubmitting, setResubmitting] = useState(false);

  const API_BASE = 'https://api-staging.mitoflux.is';
  const { getAccessTokenSilently } = useAuth0();

  const handleSearch = async () => {
    const ssnTrimmed = searchSsn.trim();
    if (!ssnTrimmed) return;

    try {
      const res = await fetchWithAuth(getAccessTokenSilently, `${API_BASE}/api/patients/search`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ssn: ssnTrimmed }),
      });

      if (res.status === 404) {
        navigate('/notfound');
        return;
      }

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`API ${res.status}: ${text}`);
      }

      const data = await res.json();
      const newPatientId = data.patientId as string | undefined;
      if (!newPatientId) throw new Error('Missing patientId in search response');

      navigate(`/doctor/patient/${encodeURIComponent(newPatientId)}`, {
        state: { name: data.name, pharmacy: data.pharmacy },
      });
    } catch (e) {
      console.error(e);
      navigate('/notfound');
    }
  };

  const searchProps: SearchBarProps = {
    value: searchSsn,
    onChange: setSearchSsn,
    onSearch: handleSearch,
    onMenuClick: () => console.log('menu'),
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setErr('');

        const res = await fetchWithAuth(
          getAccessTokenSilently,
          `${API_BASE}/api/work-orders/${encodeURIComponent(workOrderId)}`
        );
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`API ${res.status}: ${text}`);
        }

        const data = (await res.json()) as WorkOrderResponse;
        setWo(data.workOrder);
        setItems(Array.isArray(data.items) ? data.items : []);
      } catch (e: any) {
        console.error(e);
        setErr(e?.message || 'Villa kom upp');
      } finally {
        setLoading(false);
      }
    })();
  }, [workOrderId, getAccessTokenSilently]);

  const anyRejected = useMemo(() => items.some((i) => i.decision === 'DENY'), [items]);

  const rejectedDueToMissingPrescription = useMemo(() => {
    return items.some((i) => i.decision === 'DENY' && i.reason_code === 'PRESCRIPTION_MISSING');
  }, [items]);

  const canResubmit = useMemo(() => {
    if (!wo) return false;
    return rejectedDueToMissingPrescription;
  }, [wo, rejectedDueToMissingPrescription]);

  const handleResubmit = async () => {
    if (!wo) return;
    if (!prescriptionsSent) {
      alert('Vinsamlegast staðfestu að lyfseðlar hafi verið sendir.');
      return;
    }

    setResubmitting(true);
    try {
      const res = await fetchWithAuth(
        getAccessTokenSilently,
        `${API_BASE}/api/work-orders/${encodeURIComponent(wo.work_order_id)}/resubmit`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ confirmPrescriptions: true }),
        }
      );

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Resubmit API ${res.status}: ${text}`);
      }

      // After resubmit, go back to list (or you can refetch detail)
      navigate('/doctor/changes');
    } catch (e: any) {
      console.error(e);
      alert(e?.message || 'Ekki tókst að endursenda.');
    } finally {
      setResubmitting(false);
    }
  };

  if (loading) {
    return (
      <>
        <Header center={<SearchBar {...searchProps} />} />
        <Background>
          <div style={{ color: '#fff' }}>Hleð…</div>
        </Background>
      </>
    );
  }

  return (
    <>
      <Header center={<SearchBar {...searchProps} />} />

      <div className="tabs">
        <button
          className={`tab ${activeTab === 'medications' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('medications');
            navigate('/doctor');
          }}
        >
          Lyfjaskammtanir
        </button>
        <button
          className={`tab ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('history');
            navigate('/doctor/changes');
          }}
        >
          Þínar fyrri breytingar
        </button>
      </div>

      <Background>
        <div className="doc-detail">
          <button className="doc-back" onClick={() => navigate('/doctor/changes')}>
            ← Til baka
          </button>

          {err && <div style={{ color: '#fff' }}>{err}</div>}

          {!err && wo && (
            <>
              <div className="doc-detail-head">
                <div className="doc-name">Beiðni</div>
                <div className="doc-sub">
                  Send: {new Date(wo.created_at).toLocaleDateString('is-IS')}{' '}
                  {new Date(wo.created_at).toLocaleTimeString('is-IS', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                  {' • '}
                  Staða: {statusLabel[wo.status] ?? wo.status}
                </div>
              </div>

              <div className="doc-rows">
                {items.map((it) => {
                  const instruction =
                    it.proposed_payload?.instruction ||
                    it.proposed_payload?.proposedInstruction ||
                    it.proposed_payload?.note ||
                    '';

                  const decision =
                    it.decision === 'APPROVE'
                      ? 'approved'
                      : it.decision === 'DENY'
                        ? 'rejected'
                        : null;

                  const reasonLabel = it.reason_code
                    ? (REASON_LABELS[it.reason_code] ?? it.reason_code)
                    : null;

                  return (
                    <div
                      key={it.item_id}
                      className={
                        'doc-row ' +
                        (decision === 'approved'
                          ? 'ok'
                          : decision === 'rejected'
                            ? 'bad'
                            : 'pending')
                      }
                    >
                      <div className="doc-row-left">
                        <div className="doc-row-name">{it.medication_identifier}</div>
                        <div className="doc-row-meta">{kindLabel(it.action)}</div>
                      </div>

                      <div className="doc-row-mid">
                        {instruction ? (
                          <span className="doc-pill">{instruction}</span>
                        ) : (
                          <span>—</span>
                        )}
                      </div>

                      <div className="doc-row-right">
                        {decision === 'approved' && <span className="doc-chip ok">✓ Samþykkt</span>}
                        {decision === 'rejected' && (
                          <span className="doc-chip bad" title={reasonLabel || ''}>
                            ✕ Hafnað
                          </span>
                        )}
                        {!decision && <span className="doc-chip pending">Í vinnslu</span>}
                      </div>

                      {decision === 'rejected' && (
                        <>
                          {reasonLabel && <div className="doc-reason">Ástæða: {reasonLabel}</div>}

                          {it.notesPlaintext && (
                            <div className="doc-notes">
                              Athugasemd lyfjafræðings: {it.notesPlaintext}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
              </div>

              {canResubmit && (
                <div style={{ marginTop: 18 }}>
                  <div style={{ color: '#fff', fontWeight: 700, marginBottom: 8 }}>
                    Endursenda beiðni
                  </div>

                  <label style={{ display: 'flex', gap: 10, alignItems: 'center', color: '#fff' }}>
                    <input
                      type="checkbox"
                      checked={prescriptionsSent}
                      onChange={(e) => setPrescriptionsSent(e.target.checked)}
                    />
                    Já, ég hef sent lyfseðla
                  </label>

                  <button
                    style={{
                      marginTop: 12,
                      padding: '10px 16px',
                      borderRadius: 999,
                      border: 'none',
                      fontWeight: 800,
                      cursor: prescriptionsSent && !resubmitting ? 'pointer' : 'default',
                      opacity: prescriptionsSent && !resubmitting ? 1 : 0.6,
                    }}
                    disabled={!prescriptionsSent || resubmitting}
                    onClick={handleResubmit}
                  >
                    Endursenda til lyfjafræðings
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </Background>
    </>
  );
}
